import { styled, Tabs } from '@mui/material';

export const StyledDetailViewTabs = styled(Tabs)(({ theme }) => ({
  margin: theme.spacing(-4, -4, 0),
  padding: theme.spacing(0, 6),
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  zIndex: 10,
  position: 'relative'
}));
